import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameConfig} from "../FITHGameConfig";
import {FITHGameAssets} from "../FITHGameAssets";
import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {FITHBonusGameSpinView} from "./FITHBonusGameSpinView";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {IDynamiteExtraValue} from "../server/data/IFITHServerData";
import {FITHSoundManager} from "../sound/FITHSoundManager";

export class FITHBonusGameWagonAnimationsView extends FITHBonusGameSpinView {
    private _animationLayer: ScalableLayer;
    private _dwarfBg: PIXI.Sprite;
    private _dwarfSpine: PIXI.spine.Spine;
    private _dwarfBling: PIXI.spine.Spine;
    private _dwarfMultiplier: BitmapCountUp;

    private static doBombingForExtraValues(dynamiteExtraValue: IDynamiteExtraValue, chestSoundCount: number): void {
        const i: number = dynamiteExtraValue.reelPos,
            j: number = dynamiteExtraValue.rowPos;

        let totalMultiItem: BitmapCountUp,
            addedValue: number = dynamiteExtraValue.addedValue;
        if (j === 5) {
            totalMultiItem = (FITHGameModuleConfig.bonusGameVSymbolOverlayView.bottomRowWagons[i].getChildByName("totalMulti") as BitmapCountUp);

            // #240
            FITHSoundManager.playFSDynamiteChest(chestSoundCount);
        } else {
            totalMultiItem = (FITHGameModuleConfig.bonusGameVSymbolOverlayView.vOverlayItems[((i * 6) + j)].getChildByName("1xCoin") as BitmapCountUp);

            FITHSoundManager.playFSDynamiteLandsOnCoin();
        }

        addedValue += (totalMultiItem.text === "" ? 0 : Number(totalMultiItem.text.split("x")[0]));
        totalMultiItem.text = (addedValue + "x");
        totalMultiItem.pivot.set(totalMultiItem.width / 2, totalMultiItem.height / 2);

        if (!totalMultiItem.visible) {
            totalMultiItem.visible = true;
        }
    }

    public exitFS(): void {
        this._animationLayer.removeChildren();
        this._dwarfBg.visible = false;
        this._dwarfSpine.visible = false;
        this._dwarfSpine.state.clearTracks();
        this._dwarfBling.visible = false;
        this._dwarfBling.state.clearTracks();
        this._dwarfMultiplier.text = "";

        // fix -> wagon appearing after outro
        super.turnOffTrain();
    }

    public highlightDwarfSpine(): void {
        if (this._dwarfSpine.visible) {
            TweenLite.to(this._dwarfSpine.scale, 0.5, {x: 1, y: 1});
            if (this._dwarfBg.visible) {
                TweenLite.to(this._dwarfBg.scale, 0.5, {x: 1, y: 1});
            }
        }
    }

    public dimDwarfSpine(): void {
        if (this._dwarfSpine.visible) {
            TweenLite.to(this._dwarfSpine.scale, 0.5, {x: 0.9, y: 0.9});
            if (this._dwarfBg.visible) {
                TweenLite.to(this._dwarfBg.scale, 0.5, {x: 0.9, y: 0.9});
            }
        }
    }

    public animateForBombEnhancer(explodePositions: boolean[][], wagonId: number, bombItems: string, vIndex: number, dynamiteExtraValues: IDynamiteExtraValue[]): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            container: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container);
                    container.pivot.set(container.width / 2, container.height / 2);

                    wagonItem.visible = false;
                    this.animateItemsForBombEnhancer(tl, explodePositions, (wagonItem.x - wagonItem.width / 2), bombItems, container, vIndex, dynamiteExtraValues);
                    FITHGameModuleConfig.bonusGameVSymbolOverlayView.turnOffVSymLandForV(vIndex);
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);

                    wagonItem.skeleton.setSkin(null);
                    wagonItem.skeleton.setSkinByName("B" + bombItems + "_empty");
                    wagonItem.skeleton.setSlotsToSetupPose();
                    wagonItem.state.clearTracks();
                    wagonItem.updateTransform();
                    wagonItem.visible = true;
                    this.dimWagon(wagonId);
                }
            });

        tl.add(() => {}, ((55 + ((Number(bombItems) - 1) * 5)) / 30) + 0.67); // adding this, so that fire explode is completed.

        return tl;
    }

    public animateForCoinMultiplier(allVIndex: number[], wagonId: number, multiplier: string): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            container: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container);
                    container.pivot.set(container.width / 2, container.height / 2);

                    wagonItem.visible = false;
                    this.animateItemsForCoinMultiplier(tl, allVIndex, multiplier, (wagonItem.x - wagonItem.width / 2), container, "wagonGlow", "C", Number(multiplier));
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);
                    wagonItem.visible = true;

                    this.dimWagon(wagonId);
                }
            });

        // as per #39
        tl.add([
            () => {
                container.removeChildren();
                this._animationLayer.removeChild(container);
                wagonItem.visible = true;
                FITHGameModuleConfig.bonusGameVSymbolOverlayView.applyMultiAnimation(allVIndex[0], multiplier);
            },
        ], 15 / 30);
        tl.add(() => {}, 35 / 30);

        return tl;
    }

    public animateForBagCollect(wagonId: number, allVIndex: number[], totalMultiplierValue: number, newVId: number): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            container: PIXI.Container = new PIXI.Container(),
            bagContainer: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container, bagContainer);

                    bagContainer.pivot.set(bagContainer.width / 2, bagContainer.height / 2);
                    container.pivot.set(container.width / 2, container.height / 2);

                    wagonItem.visible = false;
                    this.updateItemsForBagAndChest(tl, (wagonItem.x - wagonItem.width / 2), container, allVIndex, newVId, "R1", itemsAnimationsDuration);
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);

                    wagonItem.skeleton.setSkin(null);
                    wagonItem.skeleton.setSkinByName("R1_empty");
                    wagonItem.skeleton.setSlotsToSetupPose();
                    wagonItem.state.clearTracks();
                    wagonItem.updateTransform();
                    wagonItem.visible = true;
                    this.dimWagon(wagonId);
                }
            }),
            itemsAnimationsDuration: number = (allVIndex.length * 3);

        tl.add(() => this.animateBagAndChest(tl, bagContainer, wagonItem, totalMultiplierValue, newVId, "bagParticle", "rBag", "bagScreen", (25 + itemsAnimationsDuration)), (25 + itemsAnimationsDuration) / 30);
        tl.add(() => {
            // #110
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.changeVSymToBagOrChest(newVId, "rBag", totalMultiplierValue);
            this._animationLayer.removeChild(bagContainer);
        }, (25 + itemsAnimationsDuration + 20) / 30); // so that the above is finished properly.

        return tl;
    }

    public animateForGoldBarMultiplier(allVIndex: number[], wagonId: number, multiplier: string, highestMultiplier: number): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            container: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container);
                    container.pivot.set(container.width / 2, container.height / 2);

                    wagonItem.visible = false;
                    this.animateItemsForCoinMultiplier(tl, allVIndex, multiplier, (wagonItem.x - wagonItem.width / 2), container, "effGlow2", "X", highestMultiplier);
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);
                    wagonItem.visible = true;

                    this.dimWagon(wagonId);
                }
            });

        // as per #72
        tl.add([
            () => {
                container.removeChildren();
                this._animationLayer.removeChild(container);
                wagonItem.visible = true;

                for (let i: number = 0; i < allVIndex.length; i++) {
                    FITHGameModuleConfig.bonusGameVSymbolOverlayView.applyMultiAnimationForGoldBar(allVIndex[i], multiplier, wagonId, i);
                }
            },
        ], 15 / 30);
        tl.add(() => {}, 35 / 30);

        return tl;
    }

    public animateForChestEnhancer(wagonId: number, allVIndex: number[], totalMultiplierValue: number, newVId: number): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            container: PIXI.Container = new PIXI.Container(),
            chestContainer: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container, chestContainer);

                    container.pivot.set(container.width / 2, container.height / 2);
                    chestContainer.pivot.set(chestContainer.width / 2, chestContainer.height / 2);

                    wagonItem.visible = false;
                    this.animateItemsForChestEnhancer(tl, (wagonItem.x - wagonItem.width / 2), container, allVIndex, newVId, itemsAnimationsDuration);
                    FITHGameModuleConfig.reelBackgroundView.showReelBGGlowChestEnhancer();
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);

                    wagonItem.skeleton.setSkin(null);
                    wagonItem.skeleton.setSkinByName("G_empty");
                    wagonItem.skeleton.setSlotsToSetupPose();
                    wagonItem.state.clearTracks();
                    wagonItem.updateTransform();
                    wagonItem.visible = true;
                    this.dimWagon(wagonId);
                }
            }),
            itemsAnimationsDuration: number = (allVIndex.length * 3);

        // as per #54
        tl.add(() => this.animateBagAndChest(tl, chestContainer, wagonItem, totalMultiplierValue, newVId, "chestParticle", "g2Open", "g2Open", (25 + itemsAnimationsDuration)), (25 + itemsAnimationsDuration) / 30);
        tl.add(() => {
            // #110
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.changeVSymToBagOrChest(newVId, "g2Open", totalMultiplierValue);
            this._animationLayer.removeChild(chestContainer);
        }, (25 + itemsAnimationsDuration + 20) / 30); // so that the above is finished properly.

        return tl;
    }

    public animateForDwarfEnhancer(wagonId: number, allVIndex: number[], totalMultiplierValue: number, newVId: number, animateNewV: boolean, anyBottomActive: boolean, doFast: boolean): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            wagonX: number = (wagonItem.x - wagonItem.width - 15),
            container: PIXI.Container = new PIXI.Container(),
            dwarfMultiItemsContainer: PIXI.Container = new PIXI.Container(),
            newVyPos: number = (198 + ((newVId % FITHGameConfig.instance.REELS_NUM_ORIGINAL) * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME)),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    if (animateNewV) {
                        const xPos: number = (this._trainContainer.x + wagonItem.x),
                            yPos: number = (this._trainContainer.y + wagonItem.height / 2);

                        FITHGameModuleConfig.bonusGameVSymbolOverlayView.animateAllV([newVId], xPos, yPos, newVId);
                        this._dwarfBg.position.set(wagonX, newVyPos);
                        this._dwarfSpine.position.set(wagonX, newVyPos);
                        this._animationLayer.addChild(this._dwarfBg, this._dwarfSpine);
                    }

                    this._animationLayer.addChild(container, dwarfMultiItemsContainer);
                    dwarfMultiItemsContainer.pivot.set(dwarfMultiItemsContainer.width / 2, dwarfMultiItemsContainer.height / 2);
                    container.pivot.set(container.width / 2, container.height / 2);
                },
                onComplete: () => {
                    dwarfMultiItemsContainer.removeChildren();
                    container.removeChildren();
                    this._animationLayer.removeChild(dwarfMultiItemsContainer, container);

                    if (animateNewV) {
                        this.dimWagon(wagonId);
                    }
                }
            }),
            itemsAnimationsDuration: number = (allVIndex.length * 3);

        // as per #150
        if (animateNewV) {
            tl.add(() => {
                wagonItem.skeleton.setSkin(null);
                wagonItem.skeleton.setSkinByName("DW_empty");
                wagonItem.skeleton.setSlotsToSetupPose();
                wagonItem.state.clearTracks();

                this.animateDwarf(container, wagonItem, "dw2", newVyPos);
            }, 27 / 30);
        }
        tl.add(() => this.animateDwarfSpine(wagonX, totalMultiplierValue, newVId, allVIndex, (itemsAnimationsDuration / 30), newVyPos, dwarfMultiItemsContainer, anyBottomActive, animateNewV, doFast), ((animateNewV ? 40 : 13) / 30));

        // there is a case left out in the server that dwarf can be triggered when there is no coin already on the reel system, so better not to display anything, just the dwarf.
        // and this is only triggered when there is animateNewV true, otherwise already stopped it's call from it's callee.
        if (totalMultiplierValue > 0) {
            // so that the above is finished properly.

            tl.add(() => {
                dwarfMultiItemsContainer.removeChildren();
                container.removeChildren();
                this._animationLayer.removeChild(dwarfMultiItemsContainer, container);
            }, (((animateNewV ? (40 + itemsAnimationsDuration) : (13 + itemsAnimationsDuration)) / 30) + (doFast ? 2 : 0.8)));
        } else {
            tl.add(() => {
                dwarfMultiItemsContainer.removeChildren();
                container.removeChildren();
                this._animationLayer.removeChild(dwarfMultiItemsContainer, container);
            }, ((40 / 30) + 0.2));
        }

        return tl;
    }

    // #354
    public animateSecondDwarfEnhancer(wagonId: number, newVId: number, cannActivateKilledDwarf: boolean): TimelineLite {
        const wagonItem: PIXI.spine.Spine = this._wagons[wagonId],
            wagonX: number = (wagonItem.x - wagonItem.width - 15),
            dwarfSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("dwarf")),
            container: PIXI.Container = new PIXI.Container(),
            newVyPos: number = (198 + ((newVId % FITHGameConfig.instance.REELS_NUM_ORIGINAL) * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME)),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    const xPos: number = (this._trainContainer.x + wagonItem.x),
                        yPos: number = (this._trainContainer.y + wagonItem.height / 2);

                    FITHGameModuleConfig.bonusGameVSymbolOverlayView.animateAllV([newVId], xPos, yPos, newVId);
                    dwarfSpine.visible = false;
                    dwarfSpine.position.set(wagonX, newVyPos);

                    container.pivot.set(container.width / 2, container.height / 2);
                    this._animationLayer.addChild(dwarfSpine, container);
                },
                onComplete: () => {
                    this.removeItemsSecondDwarf(dwarfSpine, container);

                    this.dimWagon(wagonId);

                    if (cannActivateKilledDwarf) {
                        FITHGameModuleConfig.reelFrameView.activateKilledDwarf();
                    }
                }
            });

        tl.add(() => {
            wagonItem.skeleton.setSkin(null);
            wagonItem.skeleton.setSkinByName("DW_empty");
            wagonItem.skeleton.setSlotsToSetupPose();
            wagonItem.state.clearTracks();

            this.animateDwarf(container, wagonItem, "dw2", newVyPos);
        }, 27 / 30);

        tl.add(() => this.setDwarfsToThrowBombState(dwarfSpine), (40 / 30));

        tl.add(() => {
            container.position.set(0);
            this.throwBombFromOneDwarfToAnother(container, this._dwarfSpine, dwarfSpine);
            this.throwBombFromOneDwarfToAnother(container, dwarfSpine, this._dwarfSpine);
        }, (75 / 30));

        tl.add(() => {
            this._dwarfMultiplier.text = "";
            new SpineTween(this._dwarfSpine, 0, "hurt");
            new SpineTween(dwarfSpine, 0, "dead");

            container.removeChildren();
        }, (90 / 30));

        tl.add(() => {
            const vOverlayItem: PIXI.Sprite = FITHGameModuleConfig.bonusGameVSymbolOverlayView.vOverlayItems[newVId];
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.removeVSymChildren(vOverlayItem);
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.applyMultiAnimation(newVId, "1");
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.resetVSym(vOverlayItem, newVId, (GameResources.getTextures(FITHGameAssets.getSymbolStateTexturePath("V") + "_brown")[0]));

            this.removeItemsSecondDwarf(dwarfSpine, container);
        }, (128 / 30));

        return tl;
    }

    // #317
    public animateDwarfMultiplierForGoldBar(multiplierNum: number): void {
        if (this._dwarfMultiplier.text) {
            const multiValue: number = (parseInt(this._dwarfMultiplier.text.split("x")[0]) * multiplierNum);

            this._dwarfMultiplier.text = (multiValue + "x");
            this._dwarfMultiplier.position.set(-3, 8);
            this._dwarfMultiplier.pivot.set(this._dwarfMultiplier.width / 2, this._dwarfMultiplier.height / 2);

            TweenLite.to(this._dwarfMultiplier.scale, 5 / 30, {x: 1.5, y: 1.5});
            TweenLite.to(this._dwarfMultiplier.scale, 4 / 30, {x: 1, y: 1, delay: 5 / 30});
        }
    }

    public animateForBottomCollectors(wagonId: number, totalMultiplierValue: number, dwarfReelId: number): TimelineLite {
        const container: PIXI.Container = new PIXI.Container(),
            tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._animationLayer.addChild(container);
                },
                onComplete: () => {
                    container.removeChildren();
                    this._animationLayer.removeChild(container);
                }
            });

        // adding this so that if dwarf is visible and also the bottom collector on that same reel is active, then it shall work as per #176
        if (dwarfReelId === wagonId && this._dwarfSpine.visible) {
            tl.add(() => {
                const endScale: PIXI.IPoint = this._dwarfSpine.scale;

                TweenLite.to(this._dwarfSpine.scale, 2 / 30, {x: 1.1, y: 1.1});
                TweenLite.to(this._dwarfSpine.scale, 15 / 30, {x: 1.2, y: 1.2, delay: 2 / 30});
                TweenLite.to(this._dwarfSpine.scale, 10 / 30, {x: endScale.x, y: endScale.y, delay: 17 / 30});

                TweenLite.delayedCall(17 / 30, () => {
                    let multiItem: BitmapCountUp = new BitmapCountUp({
                        style: {
                            font: {
                                name: "NumbersFSMulti",
                                size: 18
                            },
                            tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                        }
                    });

                    multiItem.text = this._dwarfMultiplier.text;
                    multiItem.position.set(this._dwarfSpine.x - 4, this._dwarfSpine.y + 10);
                    multiItem.pivot.set(multiItem.width / 2, multiItem.height / 2);
                    container.addChild(multiItem);
                    TweenLite.to(multiItem, 10 / 30, {y: FITHGameModuleConfig.bonusGameVSymbolOverlayView.bottomRowWagons[wagonId].y + 10});
                    TweenLite.to(multiItem, 0, {alpha: 0, delay: 10 / 30});
                });
            }, 3 / 30);
        }
        tl.add(FITHGameModuleConfig.bonusGameVSymbolOverlayView.animateItemsForBottomCollector(container, wagonId, totalMultiplierValue));

        return tl;
    }

    // #183
    public initGameDwarf(i: number, reelId: number, multiplierVal: number): void {
        // WagonX calculated based on wagon position formula in FITHBonusGameSpinView where we have added
        // (wagon.width/2) into x-position and subtracting 15 as offset
        // while displaying DW, symbol width and 15 as offset is removed from x-position to get actual positions
        // considering 175 as DW/DW-wagon width
        const firstWagonX: number = 190,
            xPosOffset: number = 115,
            wagonX: number = ((firstWagonX + (i * xPosOffset)) + (175 / 2) - 15 - 175 - 15),
            newVyPos: number = (198 + ((reelId % FITHGameConfig.instance.REELS_NUM_ORIGINAL) * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));

        if (!this._dwarfSpine.visible) {
            this._dwarfSpine.visible = true;
        }
        this._dwarfBg.position.set(wagonX, newVyPos);
        this._dwarfSpine.position.set(wagonX, newVyPos);
        this._animationLayer.addChild(this._dwarfBg, this._dwarfSpine);

        if (multiplierVal > 0) {
            this._dwarfMultiplier.text = multiplierVal + "x";
            this._dwarfMultiplier.position.set(-3, 8);
            this._dwarfMultiplier.pivot.set(this._dwarfMultiplier.width / 2, this._dwarfMultiplier.height / 2);
            this.checkForDwarfBg(multiplierVal);
        }
    }

    protected initAnimations(): void {
        super.initAnimations();
        this._animationLayer = StageManager.getLayer(FITHGameConfig.instance.LAYERS.BONUS_OVERLAY_ANIMATIONS.name);

        this._dwarfBg = new PIXI.Sprite(GameResources.getTextures("dwBg")[0]);
        this._dwarfBg.visible = false;
        this._dwarfBg.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._dwarfBg.anchor.set(0.5);

        this._dwarfSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("dwarf"));
        this._dwarfSpine.visible = false;

        this._dwarfMultiplier = new BitmapCountUp({
            style: {
                font: {
                    name: "NumbersFSMulti",
                    size: 24
                },
                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            }
        });
        this._dwarfMultiplier.text = "";

        this._dwarfBling = new PIXI.spine.Spine(GameResources.getSpineAsset("bling"));
        this._dwarfBling.visible = false;

        this._dwarfSpine.addChild(this._dwarfBling, this._dwarfMultiplier);
    }

    private animateItemsForBombEnhancer(tl: TimelineLite, explodePositions: boolean[][], wagonX: number, bombItems: string, container: PIXI.Container, newVId: number, dynamiteExtraValues: IDynamiteExtraValue[]): void {
        const effGlow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("eff_glow")[0]),
            wagonGlow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wagonGlow")[0]),
            wagonName: string = "B" + bombItems,
            symBaseImage: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures(wagonName)[0]),
            symImageScreen: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures(wagonName)[0]),
            xPos: number = (this._trainContainer.x + wagonX + symBaseImage.width / 2),
            yPos: number = (this._trainContainer.y + symBaseImage.height / 2),
            wagonContainer: PIXI.Container = new PIXI.Container(),
            mask: PIXI.Graphics = new PIXI.Graphics(),
            bombPack: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bomb" + bombItems)[0]),
            enhancerToY: number = (198 + ((newVId % FITHGameConfig.instance.REELS_NUM_ORIGINAL) * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));

        effGlow.blendMode = PIXI.BLEND_MODES.SCREEN;
        effGlow.anchor.set(0.5);
        effGlow.position.set(xPos, yPos);
        effGlow.alpha = 0;
        effGlow.scale.set(1.3);

        bombPack.visible = false;
        bombPack.anchor.set(0.5);
        bombPack.scale.set(0.5);
        bombPack.position.set(xPos, yPos);

        wagonGlow.blendMode = PIXI.BLEND_MODES.SCREEN;
        wagonGlow.anchor.set(0.5);
        wagonGlow.alpha = 0;

        this.setItems(symBaseImage, symImageScreen);

        wagonContainer.addChild(wagonGlow, symBaseImage, symImageScreen);
        wagonContainer.position.set(xPos, yPos);

        container.addChild(wagonContainer, effGlow, bombPack);

        // as per #38
        tl.to(wagonContainer.scale, 2 / 30, {x: 1.1, y: 1.1}, 0);
        tl.to(wagonContainer.scale, 6 / 30, {x: 1, y: 1}, 12 / 30);

        tl.to(wagonContainer, 2 / 30, {y: yPos - 5}, 0);
        tl.to(wagonContainer, 2 / 30, {y: yPos - 12}, 10 / 30);
        tl.to(wagonContainer, 6 / 30, {y: yPos}, 12 / 30);
        tl.to(wagonContainer, 2 / 30, {y: yPos - 12}, 18 / 30);
        tl.to(wagonContainer, 3 / 30, {y: yPos}, 20 / 30);

        tl.to(symImageScreen, 3 / 30, {alpha: 1}, 0);
        tl.to(symImageScreen, 5 / 30, {alpha: 0}, 10 / 30);

        tl.add(() => {
            mask.beginFill(0x000000, 1);
            mask.drawRect(-(symBaseImage.width / 2), -15, symBaseImage.width, symBaseImage.height);
            mask.endFill();

            symBaseImage.addChild(mask);
            symBaseImage.mask = mask;
        }, 10 / 30);

        // #240
        tl.add(() => FITHSoundManager.playFSDynamiteWagonHighlight(), 0);

        tl.to(wagonGlow, 3 / 30, {alpha: 1}, 0);
        tl.to(wagonGlow, 5 / 30, {alpha: 0}, 10 / 30);

        tl.to(effGlow.scale, 10 / 30, {x: 0, y: 0}, 0);
        tl.to(effGlow, 5 / 30, {alpha: 1}, 0);
        tl.to(effGlow, 5 / 30, {alpha: 0}, 5 / 30);

        // #103
        tl.add([
            () => bombPack.visible = true,
            TweenLite.to(bombPack.scale, 5 / 30, {x: 0.7, y: 0.7})
        ], 5 / 30);
        tl.to(bombPack.scale, 8 / 30, {x: 0.8, y: 0.8}, 10 / 30);
        tl.to(bombPack.scale, 7 / 30, {x: 0.7, y: 0.7}, 18 / 30);
        tl.to(bombPack, 4 / 30, {y: yPos - 50}, 10 / 30);
        tl.to(bombPack, 11 / 30, {y: enhancerToY}, 14 / 30);
        tl.to(bombPack, 15 / 30, {rotation: 3}, 10 / 30);
        tl.add(() => {
            bombPack.visible = false;

            FITHGameModuleConfig.bonusGameVSymbolOverlayView.applyMultiAnimation(newVId, bombItems);

            // #285
            FITHSoundManager.playFSDynamiteLandsOnCoin();
        }, 25 / 30);
        this.travelBombsToDead(tl, explodePositions, xPos, enhancerToY, container, dynamiteExtraValues);
    }

    private travelBombsToDead(tl: TimelineLite, explodePositions: boolean[][], xPos: number, yPos: number, container: PIXI.Container, dynamiteExtraValues: IDynamiteExtraValue[]): void {
        let positions: boolean[],
            count: number = 0,
            delayOffset: number,
            stoneSoundCount: number = 1,
            chestSoundCount: number = 1,
            chestExtraValuesSoundCount: number = 1;

        for (let i: number = 0; i < explodePositions.length; i++) {
            positions = explodePositions[i];
            for (let j: number = 0; j < positions.length; j++) {
                if (positions[j]) {
                    const dOverlay: PIXI.DisplayObject = ((j === 5) ? (FITHGameModuleConfig.bonusGameVSymbolOverlayView.bottomRowWagons[i]) : (FITHGameModuleConfig.bonusGameVSymbolOverlayView.dOverlayItems[i][j - 3]));
                    delayOffset = (2 * count++);
                    this.setBomb(xPos, yPos, container, delayOffset, dOverlay, tl);
                    tl.add(() => {
                        this.doBombing(i, j, container, stoneSoundCount, chestSoundCount);

                        // #279
                        if (j === 5) {
                            chestSoundCount++;
                            if (chestSoundCount === 3) {
                                chestSoundCount = 1;
                            }
                        } else {
                            stoneSoundCount++;
                            if (stoneSoundCount === 4) {
                                stoneSoundCount = 1;
                            }
                        }
                    }, (55 + delayOffset) / 30);
                }
            }
        }

        for (let i: number = 0; i < dynamiteExtraValues.length; i++) {
            const dynamiteExtraValue: IDynamiteExtraValue = dynamiteExtraValues[i], // need to declare it with const/let since it is passed as an argument in tl and don't want to loose the current value in next iteration.
                dOverlay: PIXI.DisplayObject = ((dynamiteExtraValue.rowPos === 5) ? (FITHGameModuleConfig.bonusGameVSymbolOverlayView.bottomRowWagons[dynamiteExtraValue.reelPos]) : (FITHGameModuleConfig.bonusGameVSymbolOverlayView.vOverlayItems[((dynamiteExtraValue.reelPos * 6) + dynamiteExtraValue.rowPos)]));
            delayOffset = (2 * count++);
            this.setBomb(xPos, yPos, container, delayOffset, dOverlay, tl);
            tl.add(() => {
                FITHBonusGameWagonAnimationsView.doBombingForExtraValues(dynamiteExtraValue, chestExtraValuesSoundCount);

                // #279
                if (dynamiteExtraValue.rowPos === 5) {
                    chestExtraValuesSoundCount++;
                    if (chestExtraValuesSoundCount === 3) {
                        chestExtraValuesSoundCount = 1;
                    }
                }
            }, (55 + delayOffset) / 30);
        }
    }

    private setBomb(xPos: number, yPos: number, container: PIXI.Container, delayOffset: number, dOverlay: PIXI.DisplayObject, tl: TimelineLite): void {
        const x1: number = (dOverlay.x + xPos) / 2,
            y1: number = yPos - 50,
            rotation: number = MathHelper.randomIntInRange(3, 6);

        let bomb: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bomb")[0]);
        bomb.position.set(xPos, yPos);
        bomb.anchor.set(0.5);
        bomb.scale.set(0.7);
        bomb.visible = false;

        container.addChild(bomb);

        tl.add(() => {
            bomb.visible = true;

            // #240
            FITHSoundManager.playFSDynamiteThrow();
        }, (40 + delayOffset) / 30);
        tl.to(bomb.scale, 8 / 30, {x: 0.8, y: 0.8}, (40 + delayOffset) / 30);
        tl.to(bomb.scale, 7 / 30, {x: 0.7, y: 0.7}, (48 + delayOffset) / 30);

        tl.to(bomb, 8 / 30, {x: x1, y: y1}, (40 + delayOffset) / 30);
        tl.to(bomb, 7 / 30, {x: dOverlay.x, y: dOverlay.y}, (48 + delayOffset) / 30);

        tl.to(bomb, 15 / 30, {rotation: rotation}, (40 + delayOffset) / 30);

        tl.to(bomb, 0, {alpha: 0}, (55 + delayOffset) / 30);
    }

    private doBombing(i: number, j: number, container: PIXI.Container, stoneSoundCount: number, chestSoundCount: number): void {
        let wildExplodeEff: TimelineSprite,
            deadBreak: TimelineSprite,
            deadItem: PIXI.Sprite,
            deadX: number,
            deadY: number;

        if (j === 5) {
            // #240
            FITHSoundManager.playFSDynamiteChest(chestSoundCount);

            FITHGameModuleConfig.bonusGameVSymbolOverlayView.updateBottomRowWagon(i);
        } else {
            deadItem = FITHGameModuleConfig.bonusGameVSymbolOverlayView.dOverlayItems[i][j - 3];
            deadX = deadItem.x;
            deadY = deadItem.y;

            deadBreak = new TimelineSprite(GameResources.getTextures("deadExplode"));
            deadBreak.hide();
            deadBreak.position.set(deadX, deadY);
            deadBreak.anchor.set(0.5);

            wildExplodeEff = new TimelineSprite(GameResources.getTextures("explodeEff"));
            wildExplodeEff.hide();
            wildExplodeEff.position.set(deadX, deadY);
            wildExplodeEff.anchor.set(0.5);
            wildExplodeEff.scale.set(0.4);
            wildExplodeEff.blendMode = PIXI.BLEND_MODES.SCREEN;

            container.addChild(deadBreak, wildExplodeEff);
            FITHGameModuleConfig.spinController.enableBonusReel((i * 6) + j);

            wildExplodeEff.getAnimationAutoShowHide(true, true, [4]);
            deadBreak.getAnimationAutoShowHide(true, true);
            deadItem.visible = false;

            // #240
            FITHSoundManager.playFSDynamiteStone(stoneSoundCount);
        }
    }

    private animateItemsForCoinMultiplier(tl: TimelineLite, allVIndex: number[], multiplier: string, wagonX: number, container: PIXI.Container, wagonGlowName: string, wagonNamePrefix: string, highestMultiplier: number): void {
        const effCoinMulti: TimelineSprite = new TimelineSprite(GameResources.getTextures("effCoinMulti")),
            wagonGlow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(wagonGlowName)[0]),
            wagonName: string = wagonNamePrefix + multiplier,
            symBaseImage: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures(wagonName)[0]),
            symImageScreen: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures(wagonName)[0]),
            xPos: number = (this._trainContainer.x + wagonX + symBaseImage.width / 2),
            yPos: number = (this._trainContainer.y + symBaseImage.height / 2);

        let multiplierItem: BitmapCountUp,
            coinSym: StateReelSymbol,
            multiplierToYPos: number;

        // #221
        if (multiplier !== "1") {
            effCoinMulti.blendMode = PIXI.BLEND_MODES.SCREEN;
            effCoinMulti.anchor.set(0.5);
            effCoinMulti.position.set(0, symBaseImage.height);

            wagonGlow.blendMode = PIXI.BLEND_MODES.SCREEN;
            wagonGlow.anchor.set(0.5);
            wagonGlow.alpha = 0;

            container.addChild(effCoinMulti, wagonGlow);

            tl.to(wagonGlow, 2 / 30, {alpha: 1}, 0);
            tl.to(wagonGlow, 5 / 30, {alpha: 0}, 10 / 30);

            tl.add([
                effCoinMulti.getAnimationAutoShowHide(true, true),
                // #240
                () => FITHSoundManager.playFSMultiDownToCoin()
            ], 5 / 30);
        }

        this.setItems(symBaseImage, symImageScreen);

        container.addChild(symBaseImage, symImageScreen);
        container.position.set(xPos, yPos);

        for (let i: number = 0; i < allVIndex.length; i++) {
            coinSym = Reels.getSymbol(allVIndex[i], 0)!;
            multiplierToYPos = coinSym.y + coinSym.parent.parent.y - 6;

            multiplierItem = new BitmapCountUp({
                style: {
                    font: {
                        name: "NumbersFSMulti",
                        size: 18
                    },
                    tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                }
            });

            multiplierItem.text = multiplier + "x";
            multiplierItem.position.set(-6, 16);
            multiplierItem.pivot.set(multiplierItem.width / 2, multiplierItem.height / 2);
            multiplierItem.scale.set(1.1);

            container.addChild(multiplierItem);

            tl.to(multiplierItem.scale, 3 / 30, {x: 2, y: 2}, 5 / 30);
            tl.to(multiplierItem.scale, 7 / 30, {x: 1, y: 1}, 8 / 30);

            tl.to(multiplierItem, 10 / 30, {y: multiplierToYPos}, 5 / 30);
        }

        // as per #39 and #72, both are common.
        tl.to(container.scale, 5 / 30, {x: 1.1, y: 1.1}, 0);
        tl.to(container.scale, 6 / 30, {x: 1, y: 1}, 10 / 30);

        tl.to(container, 2 / 30, {y: yPos - 5}, 0);
        tl.to(container, 6 / 30, {y: yPos}, 10 / 30);

        tl.to(symImageScreen, 5 / 30, {alpha: 1}, 0);
        tl.to(symImageScreen, 5 / 30, {alpha: 0}, 15 / 30);

        tl.add(() => {
            // #314
            if (highestMultiplier === 1) {
                FITHSoundManager.playFSMultiLandsOnCoinTiny();
            } else if (highestMultiplier > 1 && highestMultiplier < 50) {
                FITHSoundManager.playFSMultiLandsOnCoinSmall();
            } else if (highestMultiplier > 49 && highestMultiplier < 300) {
                FITHSoundManager.playFSMultiLandsOnCoinMedium();
            } else if (highestMultiplier > 299) {
                FITHSoundManager.playFSMultiLandsOnCoinLarge();
            }
        }, 15 / 30);
    }

    private updateItemsForBagAndChest(tl: TimelineLite, wagonX: number, container: PIXI.Container, allVIndex: number[], newVId: number, wagonName: string, delay: number): PIXI.Sprite {
        const effGlowBag: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("effGlow1")[0]),
            symBaseImage: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures(wagonName)[0]),
            xPos: number = (this._trainContainer.x + wagonX + symBaseImage.width / 2),
            yPos: number = (this._trainContainer.y + symBaseImage.height / 2);

        effGlowBag.anchor.set(0.5);
        effGlowBag.alpha = 0;
        effGlowBag.blendMode = PIXI.BLEND_MODES.SCREEN;

        symBaseImage.anchor.set(0.5);

        container.addChild(effGlowBag, symBaseImage);
        container.position.set(xPos, yPos);

        // as per #50
        tl.to(container.scale, 2 / 30, {x: 1.1, y: 1.1}, 0);
        tl.to(container.scale, 5 / 30, {x: 1, y: 1}, 30 / 30);

        tl.to(container, 2 / 30, {y: yPos - 5}, 0);
        tl.to(container, 2 / 30, {y: yPos - 12}, 30 / 30);
        tl.to(container, 3 / 30, {y: yPos}, 32 / 30);

        tl.add(() => symBaseImage.texture = GameResources.getTextures("wagonBottom")[0], (delay + 25) / 30);

        tl.to(effGlowBag, 2 / 30, {alpha: 1}, 0);
        tl.to(effGlowBag, 5 / 30, {alpha: 0}, 25 / 30);

        FITHGameModuleConfig.bonusGameVSymbolOverlayView.animateAllV(allVIndex, xPos, yPos, newVId);

        return symBaseImage;
    }

    private animateItemsForChestEnhancer(tl: TimelineLite, wagonX: number, container: PIXI.Container, allVIndex: number[], newVId: number, delay: number): void {
        const symBaseImage: PIXI.Sprite = this.updateItemsForBagAndChest(tl, wagonX, container, allVIndex, newVId, "G", delay);

        tl.add(() => symBaseImage.texture = GameResources.getTextures("gOpen")[0], 2 / 30);
    }

    private animateBagAndChest(tl: TimelineLite, container: PIXI.Container, wagon: PIXI.spine.Spine, totalMultiplierValue: number, newVId: number, particle: string, open: string, screen: string, startTime: number): void {
        const particles: TimelineSprite = new TimelineSprite(GameResources.getTextures(particle)),
            effGlow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("effGlow1")[0]),
            enhancerOpen: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(open)[0]),
            enhancerScreen: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(screen)[0]),
            totalMultiplier: BitmapCountUp = new BitmapCountUp({
                style: {
                    font: {
                        name: "NumbersFSMulti",
                        size: 24
                    },
                    tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                }
            }),
            xPos: number = (this._trainContainer.x + wagon.x),
            yPos: number = (this._trainContainer.y + wagon.height / 2),
            baseYForVSyms: number = 198,
            enhancerToY: number = (baseYForVSyms + ((newVId % FITHGameConfig.instance.REELS_NUM_ORIGINAL) * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));

        particles.anchor.set(0.5);
        particles.blendMode = PIXI.BLEND_MODES.SCREEN;
        particles.hide();

        effGlow.anchor.set(0.5);
        effGlow.blendMode = PIXI.BLEND_MODES.SCREEN;

        enhancerOpen.anchor.set(0.5);

        enhancerScreen.anchor.set(0.5);
        enhancerScreen.alpha = 0;
        enhancerScreen.blendMode = PIXI.BLEND_MODES.SCREEN;

        totalMultiplier.alpha = 0;
        totalMultiplier.text = totalMultiplierValue + "x";
        totalMultiplier.position.set(-6, 10);
        totalMultiplier.pivot.set(totalMultiplier.width / 2, totalMultiplier.height / 2);

        container.addChild(particles, effGlow, enhancerOpen, enhancerScreen, totalMultiplier);

        container.position.set(xPos, yPos);

        // as per #50 and #54, both are same.
        tl.to(container.scale, 5 / 30, {x: 0.9, y: 1}, startTime / 30);
        tl.to(container.scale, 5 / 30, {x: 1, y: 0.9}, (startTime + 5) / 30);
        tl.to(container.scale, 3 / 30, {x: 1, y: 1}, (startTime + 10) / 30);

        tl.to(container, 5 / 30, {y: yPos - 20}, startTime / 30);
        tl.to(container, 5 / 30, {y: yPos - 25}, (startTime + 5) / 30);
        tl.to(container, 3 / 30, {y: enhancerToY}, (startTime + 10) / 30);

        // #240
        if (open === "rBag") {
            tl.add(() => FITHSoundManager.playFSBagLands(), (startTime + 13) / 30);
        } else {
            tl.add(() => FITHSoundManager.playFSChestLands(), (startTime + 13) / 30);
        }

        tl.to(totalMultiplier, 0, {alpha: 1}, (startTime + 10) / 30);
        tl.fromTo(totalMultiplier.scale, 5 / 30, {x: 1.1, y: 1.1}, {x: 2, y: 2}, (startTime + 10) / 30);
        tl.to(totalMultiplier.scale, 5 / 30, {x: 1, y: 1}, (startTime + 15) / 30);

        tl.to(enhancerScreen, 5 / 30, {alpha: 1}, startTime / 30);
        tl.to(enhancerScreen, 5 / 30, {alpha: 0}, (startTime + 10) / 30);

        tl.to(effGlow, 5 / 30, {alpha: 0}, (startTime + 15) / 30);

        tl.add(particles.getAnimationAutoShowHide(true, true), (startTime + 10) / 30);
    }

    private animateDwarf(container: PIXI.Container, wagon: PIXI.spine.Spine, open: string, enhancerToY: number): void {
        const tl: TimelineLite = new TimelineLite(),
            enhancerOpen: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(open)[0]),
            xPos: number = (this._trainContainer.x + wagon.x),
            yPos: number = (this._trainContainer.y + wagon.height / 2);

        enhancerOpen.anchor.set(0.5);

        container.addChild(enhancerOpen);
        container.position.set(xPos, yPos);

        // #150
        tl.to(container.scale, 5 / 30, {x: 0.9, y: 1}, 0);
        tl.to(container.scale, 5 / 30, {x: 1, y: 0.9}, 5 / 30);
        tl.to(container.scale, 3 / 30, {x: 1, y: 1}, 10 / 30);

        tl.to(container, 5 / 30, {y: yPos - 20}, 0);
        tl.to(container, 5 / 30, {y: yPos - 25}, 5 / 30);
        tl.to(container, 3 / 30, {y: enhancerToY}, 10 / 30);

        // #240
        tl.add(() => FITHSoundManager.playFSDwarfLands(), 10 / 30);

        tl.add(() => container.removeChildren(), 13 / 30);
    }

    private animateDwarfSpine(wagonX: number, totalMultiplierValue: number, newVId: number, allVIndex: number[], endTime: number, newVyPos: number, container: PIXI.Container, anyBottomActive: boolean, animateNewV: boolean, doFast: boolean): void {
        if (!this._dwarfSpine.visible) {
            this._dwarfSpine.updateTransform();
            this._dwarfSpine.visible = true;
        }

        // there is a case left out in the server that dwarf can be triggered when there is no coin already on the reel system, so better not to display anything, just the dwarf.
        if (totalMultiplierValue === 0) {
            new SpineTween(this._dwarfSpine, 0, "end");

            return;
        }

        const spineTween: SpineTween = new SpineTween(this._dwarfSpine, 0, "start");

        FITHGameModuleConfig.reelBackgroundView.showReelBGGlowChestEnhancer();
        if (anyBottomActive) {
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleDarkStateForBottomCollectors();
        }

        const newVIdIdx: number = allVIndex.indexOf(newVId);
        allVIndex.splice(newVIdIdx, 1);

        // #291
        if (!animateNewV) {
            FITHSoundManager.playFSDwarfCollect();
        }

        TweenLite.delayedCall(spineTween.totalDuration(), () => {
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.animateItemsForDwarfCollector(container, allVIndex, wagonX, newVyPos);
            new SpineTween(this._dwarfSpine, 0, "loop", -1);

            TweenLite.delayedCall(endTime, () => {
                this._dwarfSpine.state.clearTracks();
                this._dwarfSpine.state.setEmptyAnimation(0, 0);
                new SpineTween(this._dwarfSpine, 0, "end");

                this._dwarfMultiplier.text = totalMultiplierValue + "x";
                this._dwarfMultiplier.position.set(-3, 8);
                this._dwarfMultiplier.pivot.set(this._dwarfMultiplier.width / 2, this._dwarfMultiplier.height / 2);
                // #291
                FITHSoundManager.playFSDwarfMultiLands();

                TweenLite.fromTo(this._dwarfMultiplier.scale, 5 / 30, {x: 1.1, y: 1.1}, {x: 2, y: 2});
                TweenLite.to(this._dwarfMultiplier.scale, 5 / 30, {x: 1, y: 1, delay: 5 / 30});
                TweenLite.delayedCall(10 / 30, () => {
                    new SpineTween(this._dwarfSpine, 0, "base");

                    this.checkForDwarfBg(totalMultiplierValue);
                    if (anyBottomActive) {
                        FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleDarkStateForBottomCollectors();
                    }
                });
            }).timeScale(doFast ? 3 : 1);
        }).timeScale(doFast ? 3 : 1);
    }

    // #354
    private setDwarfsToThrowBombState(dwarfSpine: PIXI.spine.Spine): void {
        if (!dwarfSpine.visible) {
            dwarfSpine.updateTransform();
            dwarfSpine.visible = true;
        }
        if (!this._dwarfSpine.visible) {
            this._dwarfSpine.updateTransform();
            this._dwarfSpine.visible = true;
        }

        new SpineTween(dwarfSpine, 0, "throwbomb");
        new SpineTween(this._dwarfSpine, 0, "throwbomb");
    }

    // #354
    private throwBombFromOneDwarfToAnother(container: PIXI.Container, fromDwarfSpine: PIXI.spine.Spine, toDwarfSpine: PIXI.spine.Spine): void {
        const tl: TimelineLite = new TimelineLite(),
            bombPack: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bomb")[0]);

        bombPack.anchor.set(0.5);
        bombPack.scale.set(0.7);
        bombPack.position.set(fromDwarfSpine.x, fromDwarfSpine.y);

        container.addChild(bombPack);

        tl.to(bombPack, 4 / 30, {x: fromDwarfSpine.x, y: fromDwarfSpine.y - 50}, 0);
        tl.to(bombPack, 11 / 30, {x: toDwarfSpine.x, y: toDwarfSpine.y}, 4 / 30);
        tl.to(bombPack, 15 / 30, {rotation: MathHelper.randomIntInRange(3, 6)}, 0);
    }

    // #354
    private removeItemsSecondDwarf(dwarfSpine: PIXI.spine.Spine, container: PIXI.Container): void {
        container.removeChildren();
        this._animationLayer.removeChild(dwarfSpine, container);
    }

    private checkForDwarfBg(multiValue: number): void {
        const baseFontSize: number = 24,
            baseAlpha: number = 0.25;
        let changeFactor: number = 1;
        if (multiValue > 24 && multiValue < 50) {
            changeFactor = 2;
        } else if (multiValue > 49 && multiValue < 200) {
            changeFactor = 3;
        } else if (multiValue > 199) {
            changeFactor = 4;
        }

        if (multiValue > 9) {
            this._dwarfBg.alpha = (baseAlpha * changeFactor);
            this._dwarfMultiplier.fontSize = (baseFontSize + changeFactor);
            this._dwarfBg.visible = true;
        }

        if (multiValue > 199 && !this._dwarfBling.visible) {
            this._dwarfBling.state.clearTracks();
            this._dwarfBling.skeleton.setToSetupPose();
            this._dwarfBling.skeleton.setSlotsToSetupPose();
            new SpineTween(this._dwarfBling, 0, "base", -1);
            this._dwarfBling.updateTransform();
            this._dwarfBling.visible = true;
        }
    }

    private setItems(symBaseImage: PIXI.Sprite, symImageScreen: PIXI.Sprite): void {
        symBaseImage.anchor.set(0.5);

        symImageScreen.blendMode = PIXI.BLEND_MODES.SCREEN;
        symImageScreen.anchor.set(0.5);
        symImageScreen.alpha = 0;
    }
}